import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Project } from 'models/project'
import { getAreaDetails } from 'utils/areaDetails'
import { Flex } from 'components/Flex'
import styles from './AreaTypeDetails.module.scss'

type AreaTypeDetailsProps = {
  project: Project
}

export const AreaTypeDetails: FC<AreaTypeDetailsProps> = ({ project }) => {
  const { t } = useTranslation()

  const { iconName, text, measure } = getAreaDetails(project)

  return (
    <Flex align="center" gap="sm" className={styles.areaTypeDetails}>
      <Icon name={String(iconName)} size="xl" className={styles.icon} />
      <Text size="small" weight="strong" truncate>
        {measure} {t(text)}
      </Text>
    </Flex>
  )
}

AreaTypeDetails.displayName = 'AreaTypeDetails'
